import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Button, CardFooter, CardHeader, CardBody } from "reactstrap";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import photoIcon from "../../../assets/images/photoIcon.png";
import commentIcon from "../../../assets/images/commentIcon.png";
import { Card } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Spin } from "antd";
import "../utils/style.css";
import {
  CheckOutlined,
  CloseOutlined,
  IssuesCloseOutlined,
} from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import IncidentResponse from "./IncidentResponse";

const IncidentItem = ({ inspection, user }) => {
  const { id } = useParams();
  const [openRevisionId, setOpenRevisionId] = useState(null);
  const {t} = useTranslation();
    const toggleOpen = (id) => {
    setOpenRevisionId(openRevisionId === id ? null : id);
  };

  const [isModalOpen, setIsModalOpen] = useState("");
  const [selectedInspection, setSelectedInspection] = useState(null);

  const toggleResponseModal = (inspection) => {
    setSelectedInspection(inspection);
    setIsModalOpen(!isModalOpen);
  };



  return (
    <div>
      <Card>
        <CardHeader>
        
          <div className="incident-section-title">
            {inspection?.typeInspection || "Type non défini"}
          </div>
          <Row className="text-centre ">
            <Col md={3}>
            <div >
           {t("incident_detail.type")}
         
            </div></Col>
            <Col md={3}>
            <div >
            {t("incident_detail.criticite")}
         
            </div></Col>
        
          </Row>
          <Row className="incident-title">
            <Col md={3}>
            <div >
           {inspection?.status}
         
            </div>
          </Col>
             <Col md={3}>
         <div>
    {inspection?.revisions && inspection?.revisions.length > 0 ? (
      inspection.revisions.map((rev, index) => {
      
        let pointColor;
        if (rev?.status === "Elévée") {
          pointColor = "#2FB550"; 
        } else if (rev?.status === "Modéré") {
          pointColor = "#FFCC00";
        } else {
          pointColor = "#F22A2A"; 
        }

        return (
          <div key={index}>
            <span
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: pointColor,
                display: "inline-block",
                marginRight: "8px"
              }}
            />
            {rev?.status} 
          </div>
        );
      })
    ) : (
      <p>{t("inspections.notFound")}</p>
    )}
  </div>
</Col>
          </Row>
        </CardHeader>
        <CardBody>
         <div className="text-expli">
          {t("incident_detail.explication")}
         </div>
         <div >
         {inspection?.revisions && inspection?.revisions.length > 0 ? (
            inspection.revisions.map((rev, index) => (
              <div key={index}>
                {rev?.fileName &&  (
                  <div className="">
                    <div className="text-explication">{rev?.name}</div>
                    <Row>
                      <Col>
                        <img
                          src={
                            `${process.env.REACT_APP_API_MEDIA_URL}/print/${rev?.fileName}` ||
                            avatar1
                          }
                          alt=""
                          className="insp-revision-image"
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>{t("inspections.notFound")}</p>
          )}
         </div>
        
        </CardBody>
        <CardFooter >
          <Button
            className="buttonAdd"
            title="Répondre à cette inspection"
            onClick={() => toggleResponseModal(inspection)}
          >
            {t("inspections.repond")}
    
          </Button>
        </CardFooter>
      </Card>
      {isModalOpen && (
        <IncidentResponse
          modal={isModalOpen}
          setModal={setIsModalOpen}
          toggle={toggleResponseModal}
          selectedInspection={selectedInspection}
        />
      )}
    </div>
  );
};

export default IncidentItem;
